import { useState, useEffect } from 'react'

export default function ChartWidget({ slot }) {
  // Sample data that changes over time
  const [data, setData] = useState([65, 59, 80, 81, 56, 55, 40])

  useEffect(() => {
    const interval = setInterval(() => {
      setData(prev => {
        const newData = [...prev]
        newData.shift()
        newData.push(Math.floor(Math.random() * 100))
        return newData
      })
    }, 2000)

    return () => clearInterval(interval)
  }, [])

  const maxValue = Math.max(...data)
  const labels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '16px',
        color: 'white',
      }}
    >
      <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '12px' }}>
        Weekly Analytics
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
        {data.map((value, index) => (
          <div
            key={index}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            <div
              style={{
                width: '100%',
                height: `${(value / maxValue) * 100}%`,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                borderRadius: '4px 4px 0 0',
                transition: 'height 0.5s ease',
                minHeight: '10px',
              }}
            />
            <div style={{ fontSize: '10px', opacity: 0.7 }}>
              {labels[index]}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
